<div class="search-bar">
  <input type="search" #search placeholder="{{searchPlaceholder}}"> 
</div>

